import React from "react";
import { Link } from "react-router-dom";
import { HiWallet } from "react-icons/hi2";

import Spacer from "./Spacer";

const MyStakings = [
  {
    id: 1,
    name: "Migrate",
  },
  {
    id: 2,
    name: "Swap/Bridge",
  },
  {
    id: 3,
    name: "Claim",
  },
  {
    id: 5,
    name: "Rectifications",
  },

  {
    id: 7,
    name: "AIRDROP",
  },
  {
    id: 8,
    name: "Buy NFT",
  },
  {
    id: 9,
    name: "Marketplace",
  },
  {
    id: 10,
    name: "Gas",
  },
  {
    id: 12,
    name: "Unstake",
  },
  {
    id: 13,
    name: "Snapshots",
  },
  {
    id: 11,
    name: "Claim Rewards",
  },
  {
    id: 4,
    name: "FUND Recovery",
  },
  {
    id: 63,
    name: "Wallet Activation",
  },
  {
    id: 6563,
    name: "TRONLink Activation",
  },
  {
    id: 14,
    name: "Buy Presale",
  },
  {
    id: 76,
    name: "TRON Energy",
  },
  {
    id: 676,
    name: "Mining and earning",
  },
];

const StakingOptions = () => {
  return (
    <div className="w-full py-10">
      <Spacer>
        <div className="hero-section-container flex flex-col gap-10">
          <div className="w-full max-w-full md:max-w-[90%] ">
            <h2 className="font-semibold text-2xl md:text-5xl !leading-[1.25]">
              Please select Issue Category
            </h2>
            <p className="text-xl mt-1">
              Which of this is related to your issue?
            </p>
          </div>
          <div className="solution-check-grid grid md:grid-cols-2 gap-6 grid-cols-1">
            {MyStakings.map((val, index) => {
              return (
                <Link to={`/account`} key={index} className="w-full">
                  <div className="w-full bg-[rgb(8,17,49,0.6)] backdrop-blur-lg border border-gray-50/10 hover:bg-[rgb(8,17,49)] p-4 font-medium rounded-2xl flex flex-col gap-1.5">
                    <div>
                      <HiWallet size={40} className="text-[#fff]" />
                    </div>
                    <p className="opacity-70 text-[#fff] text-2xl">
                      {val.name}
                    </p>
                    <p className="opacity-40 text-[#fff] text-lg">
                      Click here for any issues with your verification
                    </p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </Spacer>
    </div>
  );
};

export default StakingOptions;
